module.exports = __webpack_public_path__ + "media/images/common/dummy_thumbnail-7f50516a143e345731e1e5278ebbc489.jpg";